import React from 'react';
import Path from '@grebban/react-core-components/svg/Path';
import Svg from '@grebban/react-core-components/svg/Svg';

export interface SearchIconProps {
    color?: string;
    width?: string | (string | null)[];
    height?: string | (string | null)[];
}

export const SearchIcon = ({ color = 'currentColor', width, height, ...rest }: SearchIconProps) => {
    const widthVal = width ?? (height ? 'auto' : '16');
    const heightVal = height ?? (width ? 'auto' : '16');
    return (
        <Svg
            width={widthVal}
            height={heightVal}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <Path
                d="M7 12.5C10.0376 12.5 12.5 10.0376 12.5 7C12.5 3.96243 10.0376 1.5 7 1.5C3.96243 1.5 1.5 3.96243 1.5 7C1.5 10.0376 3.96243 12.5 7 12.5Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path d="M11 11L14.5 14.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </Svg>
    );
};
